import React from 'react';

import {
  BaseButton,
  useAuth,
  useLoginRequiredModal,
  useT,
} from '@repo/common';

import { ReactComponent as BookmarkOutlineIcon } from '@repo/common/assets/icons/20px/icon_20px_bookmark_outline.svg';
import { ReactComponent as BookmarkFilledIcon } from '@repo/common/assets/icons/20px/icon_20px_bookmark_filled.svg';
import { ReactComponent as HiddenIcon } from '@repo/common/assets/icons/20px/icon_20px_hidden.svg';

const DetailSidebarBottom = ({
  className = '',
  isSaved,
  isHidden,
  onToggleSave,
  onToggleHide,
}) => {
  const t = useT();
  const { isLoggedIn } = useAuth();
  const { showLoginModal } = useLoginRequiredModal();

  // 상태 전환·피드백(저장 토스트 / 숨김 배너)은 상세 페이지가 일괄 처리한다
  const handleSaveClick = () => {
    if (!isLoggedIn) {
      showLoginModal('jobboard_detail_save_cta');
      return;
    }
    onToggleSave?.(!isSaved);
  };

  const handleHiddenClick = () => {
    if (!isLoggedIn) {
      showLoginModal('jobboard_detail_hide_cta');
      return;
    }
    onToggleHide?.(!isHidden);
  };

  return (
    <div
      className={`flex items-start p-0 gap-2 w-full tabletV:max-w-[274px] ${className}`}
    >
      <BaseButton
        width='133px'
        type='text'
        size='l'
        icon={isSaved ? <BookmarkFilledIcon /> : <BookmarkOutlineIcon />}
        bgclass='bg-grayscale-gray00 border-none'
        hoverclass='hover:bg-grayscale-gray02 border-none hover:text-text-tertiary'
        textclass='text-text-tertiary'
        onClick={handleSaveClick}
        isDisabled={isHidden}
        disabledBgClass='bg-grayscale-gray00'
        disabledTextClass='text-grayscale-gray03'
      >
        {t('Save', '저장')}
      </BaseButton>
      <BaseButton
        width='133px'
        type='text'
        size='l'
        icon={<HiddenIcon />}
        bgclass='bg-grayscale-gray00 border-none'
        hoverclass='hover:bg-grayscale-gray02 border-none hover:text-text-tertiary'
        textclass='text-text-tertiary'
        onClick={handleHiddenClick}
      >
        {isHidden ? t('Hidden', '숨김됨') : t('Hide', '숨기기')}
      </BaseButton>
    </div>
  );
};

export default DetailSidebarBottom;
